module.exports = __webpack_public_path__ + "img/incomplete_count.fb9aa0a6.svg";